import classname from 'classnames'
import { assetUrl } from '@/utils/asset-url'
import { ReactComponent as IconInfo} from '@/assets/svgs/icon-info.svg'
import SelectorBoxRadio from '@/dsComponents/SelectorBoxRadio'

const SelectorBox = ({ active, disabled, label, image, submit, handleCheckInfo }) => {

	const selectorClass = classname({
		'selector-box-3': true,
		'selector-box-3--active': active,
		'selector-box-3--disabled': disabled
	})

	return (
		<div className={selectorClass} onClick={submit ? submit : null}>
			<div className="selector-box-3__left">
				{image && (<div className="selector-box__avatar" style={{ backgroundImage: `url(${image})` }}></div>)}
				<div className="selector-box-3__label">{label}</div>
			</div>

			{
				handleCheckInfo && (
					<div data-testid="info-icon" className="selector-box-3__info-icon" onClick={(e)=>{
						e.stopPropagation();
						handleCheckInfo()
					}
					}><IconInfo /></div>
				)
			}

			{
				!disabled && (
					<div className="selector-box-3__right">
						<SelectorBoxRadio active={active} />
					</div>
				)
			}
		</div>
	)
}

export default SelectorBox
